import HealthIcon from '@/assets/images/icon-health.svg';
import PupIcon from '@/assets/images/icon-pup.svg';
import StorageIcon from '@/assets/images/icon-storage.svg';
import { useAdvanceStep } from '@/lib/hooks/steps';
import { usePageTitle } from '@/lib/hooks/usePageTitle';
import { useRecWizard } from '@/lib/hooks/useRecWizard';
import SvgArrowRight from '@petplate/icons/core/ArrowRight';
import { useCallback } from 'react';
import * as Components from './components';

const SubflowIntro = () => {
  usePageTitle('Intro');

  const advanceStep = useAdvanceStep();
  const { updateWizard } = useRecWizard();

  const handleGetStarted = useCallback(() => {
    updateWizard({ introViewed: true });
    advanceStep();
  }, [updateWizard, advanceStep]);

  return (
    <Components.Container>
      <div id="hide-chat-widget" />
      <Components.Header>
        <Components.Illustration aria-label="dog with bowl illustration" />
        <Components.Title>Fresh food made easy</Components.Title>
        <Components.Description>
          In three minutes, let's create the best possible meal plan for your dog!
        </Components.Description>
      </Components.Header>
      <Components.InfoBlocksContainer>
        <Components.InfoBlock>
          <HealthIcon aria-label="vet icon" />
          <Components.InfoText>Tailored Vet Designed Nutrition</Components.InfoText>
        </Components.InfoBlock>
        <Components.InfoBlock>
          <PupIcon aria-label="puppy icon" />
          <Components.InfoText>Unmatched Human-Grade Variety</Components.InfoText>
        </Components.InfoBlock>
        <Components.InfoBlock>
          <StorageIcon aria-label="storage icon" />
          <Components.InfoText>Convenient Portioning & Feeding</Components.InfoText>
        </Components.InfoBlock>
      </Components.InfoBlocksContainer>
      <Components.IntroFooter>
        <Components.GetStartedButton
          label="Get Started"
          trailingIcon={SvgArrowRight}
          onClick={handleGetStarted}
        />
      </Components.IntroFooter>
    </Components.Container>
  );
};

export default SubflowIntro;
